import {} from '@inertiajs/core';
import { derived, writable } from 'svelte/store';
const { set, subscribe } = writable();
export const setPage = set;
export default { subscribe };
export function usePage() {
    return derived({ subscribe }, ($page) => $page);
}
